import React from "react";
import "./footer.css"; 

function Footer() {
  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-left">
          <p className="footer-brand">© 2025 Wolf, Sub-Zero & Cove Repair.</p>
        </div>
        <div className="footer-right">
          <p className="footer-rights">All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;